<template>
    <div class="flex flex-col justify-center items-center text-grey-darker bg-grey-lighter rounded-lg h-48 font-semibold">

        <EmojiSadIcon class="w-16 h-16" />

        <div class="text-2xl mt-5">
            No search results...
        </div>

    </div>
</template>

<script>
import EmojiSadIcon from '~/static/fonts/LineIcons/emoji-sad.svg';

export default {

    components: {
        EmojiSadIcon,
    },

};
</script>

<style lang="scss" scoped>
</style>
